<script>
// import MainMap from "./map/index.vue";
import { ElMessage } from "element-plus";
import axios from "axios";
import { v4 as uuid4v } from "uuid";
import mainMap from "./map/index.vue";
export default {
  components: {
    mainMap,
  },
  data() {
    return {
      messageFrom: {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      },
      joinFrom: {
        name: "",
        contact: "",
        file: "",
      },
      fileDate: {
        MD5: "",
        attachNo: "",
        oldId: "",
        oldPath: "",
        status: "",
        id: "",
      },
      fileList: [],
      attachNo: "",
      rules: {
        name: [{ required: true, message: "请输入您名称", trigger: "blur" }],
        contact: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的号码", trigger: "blur" },
        ],
        email: [{ type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入咨询内容", trigger: "blur" }],
      },
      isKK: true,
      name: "",
      site: "",
      phone: "",
      email: "",
      // 提交数据到接口
    };
  },
  mounted() {
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    this.name = this.isKK ? "福建科控自动化科技有限公司" : "北京凯创通达科技有限公司";
    this.site = this.isKK ? "福建省漳州市芗城区嘉宏广场" : "北京副中心CBD中央商务区";
    this.phone = this.isKK ? "18759688095" : "13011801198";
    this.email = this.isKK ? "fjkkauto@163.com" : "bjkctd@163.com";
    this.attachNo = uuid4v();
  },
  methods: {
    submitMessage(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const messageDto = {
            type: 0,
            name: this.messageFrom.name,
            contact: this.messageFrom.contact,
            email: this.messageFrom.email,
            company: this.messageFrom.company,
            site: this.messageFrom.site,
            content: this.messageFrom.content,
            usCompanyType: this.isKK ? 1 : 2,
          };
          // 提交数据到接口
          axios
            .post("/message/add", messageDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("留言成功");
                this.messageChange();
              } else {
                ElMessage.error("留言失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("留言失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    messageChange() {
      this.messageFrom = {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      };
    },
  },
};
</script>
<template>
  <div class="US_banner">
    <div>
      <img src="../assets/L1.jpeg" />
    </div>
  </div>
  <div class="back">
    <div class="title" style="width: 90%; margin: auto">
      <span class="line"></span>
      <span>留言咨询</span>
    </div>
    <div class="message">
      <div class="mes">
        <div class="mes-title">在线咨询</div>
        <div class="mes-from">
          <el-form :model="messageFrom" :rules="rules" ref="messageFrom">
            <el-form-item
              label="名称："
              prop="name"
              label-width="120px"
              style="height: 50px"
            >
              <el-input
                v-model="messageFrom.name"
                placeholder="您的名字"
                style="height: 50px"
              />
            </el-form-item>
            <el-form-item
              label="联系电话："
              prop="contact"
              label-width="120px"
              style="height: 50px"
            >
              <el-input
                v-model="messageFrom.contact"
                placeholder="您的电话"
                style="height: 50px"
              />
            </el-form-item>
            <el-form-item
              label="邮箱："
              prop="email"
              label-width="120px"
              style="height: 50px"
            >
              <el-input
                v-model="messageFrom.email"
                placeholder="您的邮箱"
                style="height: 50px"
              />
            </el-form-item>
            <el-form-item
              label="公司名称："
              prop="company"
              label-width="120px"
              style="height: 50px"
            >
              <el-input
                v-model="messageFrom.company"
                placeholder="您的公司"
                style="height: 50px"
              />
            </el-form-item>
            <el-form-item
              label="地址："
              prop="site"
              label-width="120px"
              style="height: 50px"
            >
              <el-input
                v-model="messageFrom.site"
                placeholder="若需要咨询购置产品，可以填上地址"
                style="height: 50px"
              />
            </el-form-item>
            <el-form-item label="资讯内容：" prop="content" label-width="120px">
              <el-input
                v-model="messageFrom.content"
                type="textarea"
                :rows="5"
                placeholder="您想咨询内容咨询内容"
              />
            </el-form-item>
          </el-form>
          <div class="mes-footer">
            <el-button
              type="primary"
              @click="submitMessage('messageFrom')"
              style="height: 50px; width: 84%; font-size: 20px"
              >提交留言</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="title" style="width: 90%; margin: auto">
      <span class="line"></span>
      <span>公司地址</span>
    </div>
    <div class="map">
      <div class="flex map-content">
        <div v-if="this.isKK" class="main-map">
          <mainMap
            content="福建科控自动化科技有限公司"
            centerlat="24.522969"
            centerlng="117.619038"
          ></mainMap>
        </div>
        <div v-else class="main-map">
          <mainMap
            content="北京凯创通达科技有限公司"
            centerlat="39.914002"
            centerlng="116.469803"
          ></mainMap>
        </div>
        <div class="map-item">
          <div class="map-title">{{ this.name }}</div>
          <div>
            <ul>
              <li>电话：{{ this.phone }}</li>
              <li>邮箱：{{ this.email }}</li>
              <li>地址：{{ this.site }}</li>
              <div style="width: 100%"><img src="../assets/wx_ewm.png" /></div>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="map-content">
        <div class="map-item">
          <div class="map-title">北京凯创通达科技有限公司</div>
          <div>
            <ul>
              <li>电话：13656043677</li>
              <li>地址：北京市通州区果园大街1号</li>
            </ul>
          </div>
        </div>
        <div class="main-map">
          <mainMap
            content="北京凯创通达科技有限公司"
            centerlat="39.893631"
            centerlng="116.656015"
          ></mainMap>
        </div>
      </div> -->
      <!-- <div class="map-content">
        <div class="map-item">
          <div class="map-title">福建科控自动化科技有限公司</div>
          <div>
            <ul>
              <li>电话：13656043677</li>
              <li>地址：福建省漳州市芗城区嘉宏广场607</li>
            </ul>
          </div>
        </div>
        <div class="main-map">
          <mainMap content="福建科控自动化科技有限公司"></mainMap>
        </div>
      </div> -->
    </div>
  </div>
</template>

<style>
.US_banner {
  width: 100%;
  height: 500px;
}
.US_banner img {
  width: 100%;
  height: 500px;
  /* filter: opacity(25%); */
}
.back {
  width: 100%;
  /* background-image: url("../assets/about.jpg"); */
  background-size: cover;
  background-position: center;
  background-color: rgba(6, 93, 255, 0.1);
}
.message {
  width: 100%;
  padding-bottom: 20px;
  padding-top: 30px;
}
.message .mes {
  text-align: center;
  margin: auto;
  width: 80%;
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  padding: 30px;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
}
.mes-title {
  padding-bottom: 20px;
  font-weight: 500;
  font-size: 26px;
  color: #535252;
}
.mes-from {
  align-content: center;
}
.map {
  margin: auto;
  width: 91%;
  list-style: none;
  padding-top: 30px;
  padding-bottom: 30px;
}
.map-content {
  width: 100%;
  margin: auto;
  /* display: inline-block; */
  justify-content: center;
}
.map-item {
  width: 25%;
  /* padding-bottom: 5px; */
  background: rgb(62, 157, 247);
  color: #ffffff;
  margin-left: 20px;
  /* height: 100%; */
}
.map-item img {
  margin-left: 9%;
  margin-top: 25px;
  width: 70%;
}
.map-title {
  font-size: 24px;
  font-weight: 600;
  padding-left: 40px;
  padding-top: 20px;
}
.map-item ul {
  list-style: none;
  font-size: 16px;
  line-height: 30px;
}
.main-map {
  width: 50%;
  background: #ffffff;
  padding: 30px;
  /* margin-top: 30px; */
  border: 2px solid #efefef;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
}

.file {
  text-align: center;
  padding-top: 50px;
  margin: auto;
  width: 80%;
}
</style>
